export const info1 = {
  id: 'about',
  lightBg: false,
  lightText: true,
  topLine: 'Members Only',
  headline: 'Gain access to insane opportunities',
  description:
    'Break into a circle of professionals dedicted to financial and personal growth, and supporting one another to win',
  buttonLabel: 'Join Us',
  imgStart: false,
  img: '/images/svg-1.svg',
  alt: 'Group',
  dark: true,
  primary: true,
  fontSize: 'fontBig',
};

export const info2 = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  topLine: 'Members Only',
  headline: 'Monthly Meetups & Trainings',
  description:
    'Unrestricted access to several trainings in diverse areas of life. Attend social meetup to network and connect',
  buttonLabel: 'Join Us',
  imgStart: true,
  img: '../../images/svg-2.svg',
  alt: 'Car',
  dark: true,
  primary: true,
  fontSize: 'big',
};

export const info3 = {
  id: 'signup',
  lightBg: false,
  lightText: true,
  topLine: 'Members Only',
  headline: 'Emotional & Financial Support',
  description:
    'We consider ourselves a family. With us you are asssured of the support needed to take huge risks in life. As long as one of us is doing well, you are covered',
  buttonLabel: 'Get started',
  imgStart: false,
  img: '../../images/svg-3.svg',
  alt: 'Car',
  dark: true,
  primary: true,
  fontSize: 'big',
};
